<template>
	<v-row>
		<v-text-field
        outlined
				:error-messages="$props.error"
				:hint="$props.hint"
				:label="$props.label"
				:mask="$props.mask"
				:placeholder="$props.placeholder" :readonly="$props.readonly"
				:type="$props.type"
				class="ml-2 mr-2"
				v-if="!isSimple"
				v-model="inputValue"></v-text-field>
		<v-text-field
        outlined
				:mask="$props.mask"
				:placeholder="$props.placeholder"
				:readonly="$props.readonly"
				:type="$props.type"
				class="simple" hide-details
				v-if="isSimple"
				v-model="inputValue"></v-text-field>
	</v-row>
</template>

<script>
	export default {
		name: "InputField",
		props: ['readonly', 'simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask', 'hint'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
